'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchErrorLogs = exports.calculateAccountPermissionsStats = exports.updateSubscription = exports.reactivateSubscription = exports.cancelSubscription = exports.fetchSubscriptions = exports.createSubscription = exports.removePlan = exports.updatePlan = exports.fetchPlans = exports.createPlan = exports.deleteMenuItem = exports.updateMenuItem = exports.createMenuItem = exports.fetchMenuItems = exports.fetchMenuItem = exports.deleteMenu = exports.updateMenu = exports.createMenu = exports.fetchMenus = exports.fetchMenu = exports.deleteSectionTemplate = exports.updateSectionTemplate = exports.createSectionTemplate = exports.fetchSectionTemplates = exports.fetchSectionTemplate = exports.deleteSection = exports.updateSection = exports.createSection = exports.fetchSections = exports.fetchSection = exports.deletePageTemplate = exports.updatePageTemplate = exports.createPageTemplate = exports.fetchPageTemplates = exports.fetchPageTemplate = exports.deletePage = exports.updatePage = exports.createPage = exports.fetchPages = exports.fetchPage = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Users
// export const fetchUsers = options => callApi('POST', '/users/fetch', options, 'application/json');
// export const updateUser = props => callApi('PUT', '/users/update', props, 'application/json');

//Pages
var fetchPage = exports.fetchPage = function fetchPage(id) {
  return (0, _callApi2.default)('GET', '/page/' + id, null, 'application/json');
};
var fetchPages = exports.fetchPages = function fetchPages(options) {
  return (0, _callApi2.default)('POST', '/page/find', options || {}, 'application/json');
};
var createPage = exports.createPage = function createPage(options) {
  return (0, _callApi2.default)('POST', '/page', options, 'application/json');
};
var updatePage = exports.updatePage = function updatePage(options, id) {
  return (0, _callApi2.default)('PUT', '/page/' + id, options, 'application/json');
};
var deletePage = exports.deletePage = function deletePage(id) {
  return (0, _callApi2.default)('DELETE', '/page/' + id, null, 'application/json');
};

var fetchPageTemplate = exports.fetchPageTemplate = function fetchPageTemplate(id) {
  return (0, _callApi2.default)('GET', '/page/template/' + id, null, 'application/json');
};
var fetchPageTemplates = exports.fetchPageTemplates = function fetchPageTemplates(options) {
  return (0, _callApi2.default)('POST', '/page/template/find', options || {}, 'application/json');
};
var createPageTemplate = exports.createPageTemplate = function createPageTemplate(options) {
  return (0, _callApi2.default)('POST', '/page/template', options, 'application/json');
};
var updatePageTemplate = exports.updatePageTemplate = function updatePageTemplate(options, id) {
  return (0, _callApi2.default)('PUT', '/page/template/' + id, options, 'application/json');
};
var deletePageTemplate = exports.deletePageTemplate = function deletePageTemplate(id) {
  return (0, _callApi2.default)('DELETE', '/page/template/' + id, null, 'application/json');
};

var fetchSection = exports.fetchSection = function fetchSection(id) {
  return (0, _callApi2.default)('GET', '/section/' + id, null, 'application/json');
};
var fetchSections = exports.fetchSections = function fetchSections(options) {
  return (0, _callApi2.default)('POST', '/section/find', options || {}, 'application/json');
};
var createSection = exports.createSection = function createSection(options) {
  return (0, _callApi2.default)('POST', '/section', options, 'application/json');
};
var updateSection = exports.updateSection = function updateSection(options, id) {
  return (0, _callApi2.default)('PUT', '/section/' + id, options, 'application/json');
};
var deleteSection = exports.deleteSection = function deleteSection(id) {
  return (0, _callApi2.default)('DELETE', '/section/' + id, null, 'application/json');
};

var fetchSectionTemplate = exports.fetchSectionTemplate = function fetchSectionTemplate(id) {
  return (0, _callApi2.default)('GET', '/section/template/' + id, null, 'application/json');
};
var fetchSectionTemplates = exports.fetchSectionTemplates = function fetchSectionTemplates(options) {
  return (0, _callApi2.default)('POST', '/section/template/find', options || {}, 'application/json');
};
var createSectionTemplate = exports.createSectionTemplate = function createSectionTemplate(options) {
  return (0, _callApi2.default)('POST', '/section/template', options, 'application/json');
};
var updateSectionTemplate = exports.updateSectionTemplate = function updateSectionTemplate(options, id) {
  return (0, _callApi2.default)('PUT', '/section/template/' + id, options, 'application/json');
};
var deleteSectionTemplate = exports.deleteSectionTemplate = function deleteSectionTemplate(id) {
  return (0, _callApi2.default)('DELETE', '/section/template/' + id, null, 'application/json');
};

var fetchMenu = exports.fetchMenu = function fetchMenu(id) {
  return (0, _callApi2.default)('GET', '/menu/' + id, null, 'application/json');
};
var fetchMenus = exports.fetchMenus = function fetchMenus(options) {
  return (0, _callApi2.default)('POST', '/menu/find', options || {}, 'application/json');
};
var createMenu = exports.createMenu = function createMenu(options) {
  return (0, _callApi2.default)('POST', '/menu', options, 'application/json');
};
var updateMenu = exports.updateMenu = function updateMenu(options, id) {
  return (0, _callApi2.default)('PUT', '/menu/' + id, options, 'application/json');
};
var deleteMenu = exports.deleteMenu = function deleteMenu(id) {
  return (0, _callApi2.default)('DELETE', '/menu/' + id, null, 'application/json');
};

var fetchMenuItem = exports.fetchMenuItem = function fetchMenuItem(id) {
  return (0, _callApi2.default)('GET', '/menu-item/' + id, null, 'application/json');
};
var fetchMenuItems = exports.fetchMenuItems = function fetchMenuItems(options) {
  return (0, _callApi2.default)('POST', '/menu-item/find', options || {}, 'application/json');
};
var createMenuItem = exports.createMenuItem = function createMenuItem(options) {
  return (0, _callApi2.default)('POST', '/menu-item', options, 'application/json');
};
var updateMenuItem = exports.updateMenuItem = function updateMenuItem(options, id) {
  return (0, _callApi2.default)('PUT', '/menu-item/' + id, options, 'application/json');
};
var deleteMenuItem = exports.deleteMenuItem = function deleteMenuItem(id) {
  return (0, _callApi2.default)('DELETE', '/menu-item/' + id, null, 'application/json');
};

//Plans
var createPlan = exports.createPlan = function createPlan(plan) {
  return (0, _callApi2.default)('POST', '/plans/create', plan, 'application/json');
};
var fetchPlans = exports.fetchPlans = function fetchPlans(options) {
  return (0, _callApi2.default)('POST', '/plans/fetch', options, 'application/json');
};
var updatePlan = exports.updatePlan = function updatePlan(plan) {
  return (0, _callApi2.default)('PUT', '/plans/update', plan, 'application/json');
};
var removePlan = exports.removePlan = function removePlan(plan_id) {
  return (0, _callApi2.default)('DELETE', '/plans/' + plan_id, null, 'application/json');
};

//Subscriptions
var createSubscription = exports.createSubscription = function createSubscription(subscriptions) {
  return (0, _callApi2.default)('POST', '/subscriptions/create', subscriptions, 'application/json');
};
var fetchSubscriptions = exports.fetchSubscriptions = function fetchSubscriptions(options) {
  return (0, _callApi2.default)('POST', '/subscriptions/fetch', options, 'application/json');
};
var cancelSubscription = exports.cancelSubscription = function cancelSubscription(_id, unpaid) {
  return (0, _callApi2.default)('POST', '/subscriptions/cancel', { _id: _id, unpaid: unpaid }, 'application/json');
};
var reactivateSubscription = exports.reactivateSubscription = function reactivateSubscription(_id) {
  return (0, _callApi2.default)('POST', '/subscriptions/reactivate', { _id: _id }, 'application/json');
};
var updateSubscription = exports.updateSubscription = function updateSubscription(subscription) {
  return (0, _callApi2.default)('PUT', '/subscriptions/update', subscription, 'application/json');
};
var calculateAccountPermissionsStats = exports.calculateAccountPermissionsStats = function calculateAccountPermissionsStats() {
  return (0, _callApi2.default)('GET', '/subscriptions/calculate-stats', null, 'application/json');
};

// Error Logs
var fetchErrorLogs = exports.fetchErrorLogs = function fetchErrorLogs(options) {
  return (0, _callApi2.default)('POST', '/error-logs/fetch', options || {}, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/v4/index.js
// module id = 749
// module chunks = 0